import { modules } from '@/modules';
import { DpAppRegistry } from '@/core/modules/DpAppRegistry';
import { container } from './di/DpContainer';

new DpAppRegistry(container).registerModules(modules);
